import React, { FC, useEffect, useState } from 'react';
import { TableComponent } from '../../components/TableComponent';
import { ClientsLogsTableRowData } from '../../components/developers/client-logs/ClientsLogsTableRowData';
import {
	ClientsLogsFilterSection
} from '../../components/developers/widget-configuration/ClientsLogsFilterSection';
import { usePageContext } from '../../store/page-context';
import { useDebounce } from 'use-debounce';
import clsx from 'clsx';
import { PagePagination } from '../../components/pagination/PagePagination';
import { useLocation } from 'react-router';
import { fetchClientsLogsData } from '../../store/activity/actions/clientsLogs';
import { useActivityContext } from '../../store/activity/activity-context';

const COLUMNS = [
	{
		key: 'button',
		additionalColumnClassName: 'w-10px'
	},
	{
		key: 'request',
		title: 'Request'
	},
	{
		key: 'status',
		title: 'Status'
	},
	{
		key: 'date',
		title: 'Date'
	},
	{
		key: 'environment',
		title: 'Environment'
	},
	{
		key: 'type',
		title: 'Type'
	},
	{
		key: 'description',
		title: 'Description'
	},
	{
		key: 'requestName',
		title: 'Request Name'
	}

];

export interface IClientLogsData {
	count: number;
	currentPage: number;
	totalPages: number;
	nextPage: number | null;
	prevPage: number | null;
	pageSize: number;
	displayData: IClientLogsRowData[];
}

export interface IClientLogsRowData {
	date: string | null;
	description: string | null;
	environment: string | null;
	id: string | null;
	status: string | null;
	statusCode: string | null | number;
	type: string | null;
	method: string;
	name: string;
	path: string;
	request: {
		date: string | null;
		environment: string | null;
		id: string | null;
		orderId: string | null;
		payload: string;
	};
	response: {
		description: string | null;
		latency: string | null;
		status: string | null;
		statusCode: string | null;
		payload: string;
	}

}

export const paymentTransactionsPrepareData = (data): IClientLogsData => ({
	count: data?.totalItemCount ?? 0,
	currentPage: data?.pageNumber ?? 1,
	totalPages: data?.pageCount ?? 1,
	nextPage: data?.hasNextPage,
	prevPage: data?.hasPreviousPage,
	pageSize: data?.pageSize,
	displayData: data?.rows ?? []
});

export const ClientLogs: FC = () => {
	const { search, pathname } = useLocation();
	const { searchValue, setSearchValue, chosenDate, setChosenDate } = usePageContext();
	const { activityState: { clientsLogsData, isClientsLogsDataLoading }, dispatch } = useActivityContext();
	const getPageNumber = (path: string): number => {
		if (path) {
			const page = Number(path.replace(`?page=`, ''));
			if (!isNaN(page)) {
				return page;
			}
		}

		return 1;
	};

	const [currentPage, setCurrentPage] = useState(getPageNumber(search));

	const [value] = useDebounce(searchValue?.toLowerCase()?.trim(), 1000);

	useEffect(() => {
		void fetchClientsLogsData(dispatch, currentPage, chosenDate, value);
	}, [value, chosenDate, currentPage]);

	return (
		<>
			<ClientsLogsFilterSection
				searchValue={searchValue}
				setSearchValue={setSearchValue}
				date={chosenDate}
				setDate={setChosenDate}
			/>
			<div className="card">
				<TableComponent
					column={COLUMNS}
					isDataLoading={isClientsLogsDataLoading}
					tableLoadingHeight="users-list-table-loading-height"
					tableData={clientsLogsData?.displayData}
					getRowComponent={(el: IClientLogsRowData): JSX.Element => (
						<ClientsLogsTableRowData key={el?.id} data={el}/>
					)}
				/>
				{clientsLogsData.totalPages > 1 && (
					<div className={clsx('card-body', isClientsLogsDataLoading && 'd-none')}>
						<PagePagination
							data={clientsLogsData}
							currentPage={currentPage}
							setCurrentPage={setCurrentPage}
							pathname={pathname}
							/>
					</div>
				)}
			</div>
		</>
	);
};
